export default __webpack_public_path__ + "static/media/330_dummy2016-schmuck01-de.5e706969.png";